var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSaveCancelation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7506 5.46098V0.5H14.6684L19.5 5.03585V15.9996C19.5 17.3851 18.3935 18.5 17.0408 18.5H3.14269C1.68853 18.5 0.5 17.303 0.5 15.8118V3.00041C0.5 1.61182 1.60565 0.5 2.96311 0.5H3.43519V5.46098C3.43519 6.1078 3.9587 6.63383 4.60668 6.63383H11.5792C12.2271 6.63383 12.7506 6.1078 12.7506 5.46098ZM15.2606 17.2702C16.1103 17.2702 16.8029 16.5811 16.8029 15.7258V10.2609C16.8029 9.41185 16.1167 8.71639 15.2606 8.71639H4.73941C3.88965 8.71639 3.19705 9.40549 3.19705 10.2609V15.7258C3.19705 16.5748 3.88331 17.2702 4.73941 17.2702H15.2606Z",
    fill: "#888888",
    stroke: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.6111H14",
    stroke: "#888888",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.6666H14",
    stroke: "#888888",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.7778H14",
    stroke: "#888888",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55013 0.5H10.4499C10.4733 0.5 10.4899 0.505623 10.5 0.510816V3.71141C10.4899 3.7166 10.4733 3.72222 10.4499 3.72222H5.55013C5.52671 3.72222 5.51009 3.7166 5.5 3.71141V0.510816C5.51009 0.505623 5.52671 0.5 5.55013 0.5Z",
    fill: "#888888",
    stroke: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSaveCancelation);
export default __webpack_public_path__ + "static/media/headerSaveCancelation.7bc65ed6df46c781aa9185f527afca22.svg";
export { ForwardRef as ReactComponent };